import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15389e1e")

_pushScopeId("data-v-15389e1e")
const _hoisted_1 = { class: "SSwitch" }
const _hoisted_2 = { class: "SSwitch__wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
        return (_openBlock(), _createBlock("div", {
          class: ["SSwitch__value", {
                    active: i === _ctx.selectedValueIndex,
                }],
          key: `${i}-${option}`,
          ref: _ctx.pushRef,
          onClick: ($event: any) => (_ctx.changeValue(i))
        }, _toDisplayString(option.name), 11, ["onClick"]))
      }), 128)),
      _createVNode("div", {
        class: ["SSwitch__thumbler", {
                    red: _ctx.theme === 'red',
                    primary: _ctx.theme === 'primary',
                    green: _ctx.theme === 'green',
                    blue: _ctx.theme === 'blue',
                }],
        ref: "thumbler"
      }, null, 2)
    ])
  ]))
})